import { ReactNode } from 'react'
import { AutoFillGrid } from './auto-fill-grid'
import { DashboardPlaceholder } from './placeholder'

type CampaignGridProps<T> = {
	data: T[]
	renderCard: (item: T, index: number) => ReactNode
	topBar?: ReactNode
	pageMaxWidth?: number
	gap?: number
	showPlaceholders?: boolean
}

export function CampaignGrid<T>({
	data,
	renderCard,
	topBar,
	pageMaxWidth = 1600,
	gap = 20,
	showPlaceholders = true,
}: CampaignGridProps<T>) {
	const renderPlaceholder = showPlaceholders ? () => <DashboardPlaceholder /> : undefined

	return (
		<div className="flex flex-col items-center w-full pb-20">
			<div
				className="w-full"
				style={{
					maxWidth: `${pageMaxWidth}px`,
				}}
			>
				{topBar && (
					<div className="mb-6">
						{topBar}
					</div>
				)}
				<AutoFillGrid
					data={data}
					renderCard={renderCard}
					renderPlaceholder={renderPlaceholder}
					minCardWidth={300}
					gap={gap}
				/>
			</div>
		</div>
	)
}
